<template>
  <div class="meeting">
    <Hero
      class="hero"
      heading="SeenThis Town hall"/>
    <h2 class="title" v-text="title" />
    <div class="video" :class="{videoPaused, mouseMoved}" @click="togglePlay">
      <video ref="video" :src="video" controls poster="poster.png"></video>
      <button>
        <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M8 5v14l11-7z" v-if="videoPaused"/>
          <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" v-else/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import Hero from '../components/hero.vue';

export default {
  name: 'Meeting',
  components: {
    Hero,
  },
  data() {
    return {
      videoPaused: true,
      mouseMoved: false,
      title: '',
      video: '',
    };
  },
  mounted() {
    const updatePause = () => {
      this.videoPaused = this.$refs.video.paused;
    };
    this.$refs.video.addEventListener('pause', updatePause);
    this.$refs.video.addEventListener('play', updatePause);
    this.$refs.video.addEventListener('mousemove', () => this.moved());
    const date = window.location.href.split('/').pop();
    this.title = new Date(date).toDateString();
    this.video = `https://portal.seenthis.co/download/video/meeting-${date}.mp4`;
  },
  methods: {
    moved() {
      let timer = null;
      if (timer) {
        clearTimeout('timer');
      }
      timer = setTimeout(() => {
        this.mouseMoved = false;
      }, 2000);
      this.mouseMoved = true;
    },
    togglePlay() {
      this.moved();
      if (this.$refs.video.paused) {
        this.$refs.video.play();
      } else {
        this.$refs.video.pause();
      }
    },
  },
};
</script>


<style lang="stylus" scoped>
  @require '../style/colors'

  .meeting
    background-color: #1A1A1A
  h2
    color: #fff
    font-weight: normal
    text-align: center
    margin-bottom: 1em
    font-size: 36px
  .video
    width: 100vw
    height: 56vw
    max-height: calc(100vh - 98px)
    position: relative
    &.mouseMoved button, &.videoPaused button
      opacity: 1
    video
      display: block
      width: 100%
      height: 100%
      background-color: #1A1A1A
      object-fit: contain
    button
      position: absolute
      width: 50px
      height: 50px
      margin: auto
      top: 0
      right: 0
      bottom: 0
      left: 0
      opacity:0
      appearance: none
      outline: none
      display: flex
      align-items: center
      justify-content: center
      background-color: #ff5500
      border: none
      border-radius: 50%
      transition: opacity .4s
</style>
